const {
  NODE_ENV,
  VUE_APP_PROD_URL,
  VUE_APP_DEV_URL
} = process.env;

export default {
  backendUrl: NODE_ENV === 'production' ? VUE_APP_PROD_URL : VUE_APP_DEV_URL
};
